import React, {useEffect, useState} from "react";
import {delRecordingSession, getRecordingSessions} from "../../lib/api";
import ProfileHeader from "../Headers/ProfileHeader";
import {Accordion, Card} from "react-bootstrap";
import {TrashButton} from "../Shared/Buttons";

function RecordingSessions(props: { cognitoUser: any }) {
  const {cognitoUser} = props;
  const [recordingSessions, setRecordingSessions] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
      refreshRecordingSessions();
    }, []
  )

  function refreshRecordingSessions() {
    getRecordingSessions().then(response => {
      if (response.ok) {
        setLoading(false);
        response.json().then(json => {
          setRecordingSessions(json.recordingSessions);
        });
      }
    })
  }

  interface CustomDateTimeFormatOptions extends Intl.DateTimeFormatOptions {
    dateStyle?: 'full' | 'long' | 'medium' | 'short';
    timeStyle?: 'full' | 'long' | 'medium' | 'short';
  }

  function formatUTCDatetime(utcDatetimeString: string) {
    const utcDate = new Date(utcDatetimeString);
    const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    const formatter = new Intl.DateTimeFormat(undefined, {
      dateStyle: 'short',
      timeStyle: 'long',
      timeZone: userTimezone
    } as CustomDateTimeFormatOptions);

    const formattedDatetime = formatter.format(utcDate);
    return formattedDatetime;
  }

  function deleteRecordingSession(id: string) {
    if (!window.confirm("Delete this recording? This cannot be undone.")) {
      return;
    }
    delRecordingSession(id).then((response) => {
      if (response.ok) {
        refreshRecordingSessions();
      }
    })
  }

  const recordingSessionsHtml = recordingSessions.map(function (recordingSession: any, index: number) {
    return (
      <Accordion defaultActiveKey="recording-session-0" key={`recording-session-${index}`}>
        <Card>
          <Accordion.Toggle as={Card.Header} eventKey={`recording-session-${index}`}>
            {formatUTCDatetime(recordingSession.createdAt)} in Villa: {recordingSession.teamName}
          </Accordion.Toggle>
          <Accordion.Collapse eventKey={`recording-session-${index}`}>
            <Card.Body>
              <p>
                <div className="d-flex justify-content-between">
                  <div>
                    Participants: {recordingSession.participants.join(', ')}<br/><br/>
                  </div>
                  <div className="ml-2">
                    <TrashButton onClick={() => deleteRecordingSession(recordingSession.id)} visible={true}/>
                  </div>
                </div>
                {recordingSession.summary}
              </p>
            </Card.Body>
          </Accordion.Collapse>
        </Card>
      </Accordion>
    );
  });

  if (loading) {
    return (
      <>
        <ProfileHeader cognitoUser={cognitoUser} title="Recordings" linkToHome="/home"/>
        <section className="container main recordings p-4 rounded">
          <h4>Loading...</h4>
        </section>
      </>
    )
  } else if (recordingSessions.length === 0) {
    return (
      <>
        <ProfileHeader cognitoUser={cognitoUser} title="Recordings" linkToHome="/home"/>
        <section className="container main recordings p-4 rounded">
          <h4>You have not yet created any recordings VR</h4>
        </section>
      </>
    )
  }

  return (
    <>
      <ProfileHeader cognitoUser={cognitoUser} title="Recordings" linkToHome="/home"/>
      <section className="container main recordings p-4 rounded">
        <h4>Recordings you have made in VR</h4>
        <Accordion defaultActiveKey="0">
          {recordingSessionsHtml}
        </Accordion>
      </section>
    </>
  );
}

export default RecordingSessions;
